/**
 * Users Table Skeleton Loader (JSX)
 * Shows skeleton UI for the users table while loading data
 * Used in Step 2 - Invite Users Page
 */

import React from 'react';

export const UsersTableSkeleton = () => {
  return (
    <div className="bg-white rounded-[20px] border border-[#d3d6dc] shadow-[0px_2px_10px_0px_rgba(0,0,0,0.15)] p-6 animate-pulse">
      {/* Header Section Skeleton */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        {/* Title */}
        <div className="h-7 w-48 bg-[#e5e5e5] rounded-md" />

        {/* Search and Add Button Row */}
        <div className="flex gap-3 w-full sm:w-auto">
          {/* Search Bar Skeleton */}
          <div className="h-10 flex-1 sm:w-64 bg-[#e5e5e5] rounded-md" />

          {/* Add User Button Skeleton */}
          <div className="h-10 w-32 bg-[#e5e5e5] rounded-md" />
        </div>
      </div>

      {/* Table Skeleton */}
      <div className="overflow-x-auto">
        <table className="w-full">
          {/* Table Header Skeleton */}
          <thead>
            <tr className="border-b border-[#e5e5e5]">
              <th className="text-left p-4">
                <div className="size-5 bg-[#e5e5e5] rounded" />
              </th>
              <th className="text-left p-4">
                <div className="h-4 w-16 bg-[#e5e5e5] rounded-md" />
              </th>
              <th className="text-left p-4">
                <div className="h-4 w-20 bg-[#e5e5e5] rounded-md" />
              </th>
              <th className="text-left p-4">
                <div className="h-4 w-12 bg-[#e5e5e5] rounded-md" />
              </th>
              <th className="text-left p-4">
                <div className="h-4 w-20 bg-[#e5e5e5] rounded-md" />
              </th>
              <th className="p-4">
                <div className="h-4 w-16 bg-[#e5e5e5] rounded-md ml-auto" />
              </th>
            </tr>
          </thead>

          {/* Table Body Skeleton - 5 rows */}
          <tbody>
            {[1, 2, 3, 4, 5].map((index) => (
              <tr key={index} className="border-b border-[#e5e5e5]">
                {/* Checkbox */}
                <td className="p-4">
                  <div className="size-5 bg-[#e5e5e5] rounded" />
                </td>

                {/* Name */}
                <td className="p-4">
                  <div
                    className="h-4 bg-[#e5e5e5] rounded-md"
                    style={{ width: `${60 + index * 8}%` }}
                  />
                </td>

                {/* Email */}
                <td className="p-4">
                  <div
                    className="h-4 bg-[#e5e5e5] rounded-md"
                    style={{ width: `${70 + index * 5}%` }}
                  />
                </td>

                {/* Role */}
                <td className="p-4">
                  <div className="h-6 w-20 bg-[#e5e5e5] rounded-full" />
                </td>

                {/* Date */}
                <td className="p-4">
                  <div className="h-4 w-24 bg-[#e5e5e5] rounded-md" />
                </td>

                {/* Actions */}
                <td className="p-4">
                  <div className="flex justify-end gap-2">
                    <div className="size-8 bg-[#e5e5e5] rounded" />
                    <div className="size-8 bg-[#e5e5e5] rounded" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
